import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Accounts, Storage } from 'actions';
import { getHoldTotalMarketValue, hasNegativeWeight } from 'utils/helpers';
import CashAnalyze from '../../components/CashAnalyze';
import { hasCurrencyOptions } from '../../utils/helpers';

class MultipleAccountCash extends Component {
  /*
    Creates a "Cash holding" in order to account for the amount of cash in the analysis
    The security_detail parameter is required for the "convertToTickersAndWeights" function in the utils/helpers.js file
  */
  getCash = (account) => {
    const cash = {
      account: 'Overview',
      account_id: 'Overview',
      currency: 'CAD',
      market_value: account.cash,
      name: 'Cash',
      security: 'CASH:MKT',
      ticker: 'CASH:MKT',
      security_detail: {
        exchange_symbol: 'CASH:MKT',
        ticker: 'CASH:MKT',
        long_name: 'Cash',
        unadjusted_closing_price: {
          CAD: 1,
          USD: 1,
        },
      },
    };
    const holdingsCash = account.holdings.concat(cash);
    return holdingsCash;
  };

  analyze = (holdings) => {
    const { dispatch, history, selectedAccountList, user_region } = this.props;
    const gicHoldings = holdings.filter((holding) => holding.gic_ticker);
    Storage.removeItem('pwpa-has-exclude-holding');
    const concatAccountNames = selectedAccountList
      .map((acc) => acc.user_institution)
      .join(' - ');

    return dispatch(
      Accounts.analyze(
        holdings,
        history,
        { user_institution: concatAccountNames },
        gicHoldings,
        user_region
      )
    );
  };

  render() {
    const {
      dispatch,
      selectedAccountOverview,
      user_region,
      pwpaExchangeRate,
      language,
    } = this.props;
    const hasNegativeWeights = hasNegativeWeight(
      selectedAccountOverview.holdings
    );
    const isNegativePort =
      getHoldTotalMarketValue(
        selectedAccountOverview,
        pwpaExchangeRate,
        user_region
      ) < 0;

    return (
      <CashAnalyze
        hasNegativeWeights={hasNegativeWeights}
        isNegativePort={isNegativePort}
        analyze={this.analyze}
        dispatch={dispatch}
        holdings={this.getCash(selectedAccountOverview)}
        language={language}
        hasCurrencyOption={hasCurrencyOptions(
          user_region,
          selectedAccountOverview.currency
        )}
      />
    );
  }
}

MultipleAccountCash.propTypes = {
  selectedAccountOverview: PropTypes.object,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  selectedAccountList: PropTypes.array,
  user_region: PropTypes.string,
  pwpaExchangeRate: PropTypes.number,
  language: PropTypes.string,
};

MultipleAccountCash.defaultProps = {
  dispatch: () => {},
  history: {},
  selectedAccountOverview: {},
  selectedAccountList: [],
  user_region: 'CA',
  pwpaExchangeRate: 0,
  language: 'en',
};

export default connect((state) => ({
  selectedAccountOverview: state.Accounts.selectedAccountOverview,
  selectedAccountList: state.Accounts.selectedAccountList,
  user_region: state.Storage.user_region,
  pwpaExchangeRate: state.Storage['pwpa-exchange-rate'],
  language: state.Storage.language,
}))(MultipleAccountCash);
